/* eslint-disable security/detect-object-injection */
/* eslint-disable padding-line-between-statements */
import { Button, Icon } from '@jutro/components';
import { TranslatorContext, withIntl } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import '@xengage/gw-platform-translations';
import { DatatableUtil, LobIconUtil } from '@xengage/gw-portals-util-js';
import appConfig from 'app-config';
import cx from 'classnames';
import { PolicyService, JobService } from 'gw-capability-gateway';
import { AccountService } from 'gw-capability-gateway-policy';
import {
    Currency as CurrencyField,
    FieldLinkComponent,
} from 'gw-components-platform-react';
import {
    SelectProducerCode,
    withProducerContext,
} from 'gw-gateway-common-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import TWIAJobRequalificationUtil from 'gw-capability-gateway-react//Utils/TWIAJobRequalificationUtil';
import PolicyAdvanceFilter from '../Policy/AdvancedFilter/AdvancedPolicyFilter';
import messages from './Policies.messages';
import metadata from './Policies.metadata.json5';
import styles from './Policies.module.scss';

const { gatewayParamConfig = {} } = appConfig;
const availableAccountID = ['quotes', 'renewal', 'change', 'cancellation', 'renewalRequalification'];
const availableAdvancedFilterID = [
    'Quotes',
    'Renewal',
    'Change',
    'Cancellation',
];

const tableHeadings = {
    recentlyViewedTile: messages.recentlyViewedPolicies,
    recentlyIssuedTile: messages.recentlyIssuedPolicyForPastXDays,
    delinquentTile: messages.delinquentPolicies,
    Policies: messages.policies,
    Quotes: messages.policyLandingQuotes,
    Renewal: messages.policyLandingRenewal,
    Change: messages.policyLandingChange,
    Cancellation: messages.policyLandingCancellation,
    quotes: messages.openQuotes,
    renewal: messages.openRenewals,
    change: messages.openChanges,
    cancellation: messages.openCancellations,
    renewalRequalification: messages.requalificationRenewals
};
const currentViews = ['Quotes', 'Renewal', 'Change', 'Cancellation', 'RenewalRequalification'];
const currentViewsToJobType = {'Quotes': 'Submission', 'Renewal': 'Renewal', 'Change': 'PolicyChange', 'Cancellation': 'Cancellation'};
const currentViewsToCount = {
        'Quotes': 'quotesCount',
        'Renewal': 'renewalCount',
        'Change': 'changeCount',
        'Cancellation': 'cancellationCount',
        'RenewalRequalification': 'renewalRequalificationCount'
};

const defaultTableConfig = {
    page: 0,
    pageSize: 10
};

class Policies extends Component {
    static propTypes = {
        match: PropTypes.shape({
            path: PropTypes.string,
            params: PropTypes.shape({
                PolicyNumber: PropTypes.string,
            }),
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
        }).isRequired,
        location: PropTypes.shape({
            state: PropTypes.string,
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        intl: PropTypes.func.isRequired,
        producerCode: PropTypes.string.isRequired,
    };

    static contextType = TranslatorContext;

    state = {
        toggleFilter: true,
        currentView: '',
        policyData: [],
        policyStatusCodes: [],
        policyLobs: [],
        recentlyIssuedResponse: [],
        delinquentData: [],
        renewalRequal: [],
        accountData: [],
        quotesCount: 0,
        renewalCount: 0,
        changeCount: 0,
        renewalRequalificationCount: '-',
        cancellationCount: 0,
        delinquentCount: 0,
        recentlyIssuedCount: 0,
        recentlyViewedTableVisible: false,
        tableData: [],
        policyTableVisible: false,
        policyLandingLoader: true,
        allDelinquentPolicies: [],
        policyNumberVisible: true,
        statusCodes: [],
        billingStatusCodes: [],
        lobCodes: [],
        tableConfig: defaultTableConfig,
    };

    startLoad() {
        const { authHeader } = this.props;
        const { initialRenderComplete } = this.state;
        if (authHeader && !initialRenderComplete) {
            const { location } = this.props;
            const { state } = location;
            let viewSelected = 'recentlyViewedTile';
            if (state) {
                const { selectedTile } = state;
                viewSelected = selectedTile || viewSelected;
                const isPolicyNumberVisible = selectedTile !== 'quotes';
                this.setState({
                    currentView:
                        selectedTile !== undefined
                            ? selectedTile
                            : 'recentlyViewedTile',
                    policyNumberVisible: isPolicyNumberVisible,
                });
            } else {
                this.setState({ currentView: 'recentlyViewedTile' });
            }
            this.loadInitialData(viewSelected);
            this.setState({ initialRenderComplete: true });
        }
    }

    // US31335 disable 'Show All' on drop downs
    createViewAllObserver(instance) {
        return new MutationObserver((mutationList, observer) => {
            mutationList.filter(ml => ml.type === 'childList').forEach(m => {
                m.addedNodes.forEach(node => {
                    if (node.nodeType == Node.ELEMENT_NODE) {
                        const showAll = node.querySelector('[value="All"]');
                        if (showAll) showAll.style.display = 'none';
                    }
                });
            });
        });
    }

    componentDidMount() {
        this.startLoad();
        if (!this.viewAllObserver) {
            const state = this.state;
            this.viewAllObserver = this.createViewAllObserver(this);
            this.viewAllObserver.observe(document.body, { childList: true, subtree: true });
        }
    }

    componentDidUpdate() {
        this.startLoad();
    }

    componentWillUnmount() {
        this.viewAllObserver?.disconnect();
    }

    getResponse = (currentView, selectedProducerCode) => {
        const { policyData } = this.state;
        const policyItems = [];
        this.setState({
            recentlyViewedTableVisible: true,
            policyTableVisible: false,
        });
        policyData?.forEach(policyDetails => {
            let tableDataList;
            if (currentView === 'recentlyViewedTile') {
                if (selectedProducerCode === 'all') {
                    tableDataList = policyDetails;
                } else if (selectedProducerCode === 'myWork') {
                    tableDataList = policyDetails.createdByMe;
                } else {
                    const producerCode =  policyDetails.producerCodeOfService;
                    tableDataList = producerCode === selectedProducerCode;
                }
            }
            if (tableDataList) {
                policyItems.push(this.getRecentlyViewedDisplayObject(policyDetails));
            }
            return true;
        });
        this.setState({
            tableData: policyItems || [],
        });
    };

    // sortJobNumberByDesc = (current, next) => next.jobNumber - current.jobNumber;
     
    dateFormatValue = (items,index,path) => {
        const { intl } = this.props;
        return intl.formatDate(
            new Date(items[path.path]),
            {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
            }
        );
    };

    getRecentlyViewedDisplayObject = item => {
        return {
            productCode: item.product.productCode,
            insuredName: item.primaryInsuredName,
            policyType: item.policyLines[0].policyType_TWIA,
            displayStatus: item.displayStatus,
            accountNumber: item.accountNumber,
            policyNumber: item.policyNumber,
            account: item.accountNumber,
            accountHolderName: item.accountHolderName,
            primaryInsuredName: item.primaryInsuredName,
            primaryRiskLocation_TWIA: item.primaryRiskLocation_TWIA.displayName,
            premium: item.totalCost_TWIA, // DE19160
            effectiveDate: item.effective,
            expirationDate: item.isCancelled ? item.cancelledOrExpirationDate_TWIA
                : item.expiration // DE16726
        };
    };

    getPolicyDisplayObject = (item, producerCode, translator, intl) => {
        return {
            productCode: item.product.productCode,
            premium: item.totalPremium,
            jobStatus: item.status,
            jobNumber: item.jobNumber,
            accountNumber: item.accountNumber,
            accountHolderName: item.accountHolderName,
            policyNumber: item.policyNumber,
            canUserView: item.canUserView,
            account: item.accountNumber,
            propertyAddress: item.address_TWIA,
            policyType: item.policyLines[0].policyType_TWIA,
            requalStatus: TWIAJobRequalificationUtil.jobReQualStatus(item, translator(messages.requalified), translator(messages.requalPending) ),
            requalExpires:  intl.formatDate(
                new Date(item.policyEndDate_TWIA), // DE19152
                {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                }
            ),
            effectiveDate: intl.formatDate(
                new Date(item.policyEffectiveDate),
                {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                }
            ),
            quoteExpires: intl.formatDate(
                new Date(item.offerExpirationDate_TWIA),
                {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                }
            ),
            created: intl.formatDate(
                new Date(item.createTime),
                {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                }
            ),
        };
    };
    

    getAccountResponseData = producerCode => {
        const { currentView } = this.state;
        const count = this.state[currentViewsToCount[this.parseCase(currentView)]];
        this.setState({
            recentlyViewedTableVisible: false,
            policyTableVisible: true, 
            tableData: [],
        });
    };

    getTileValue = producerCode => {
        const { accountData, 
                renewalRequalificationCount, 
                recentlyIssuedCount,        
                delinquentCount 
              } = this.state;
        let cancellationCount, changeCount, renewalCount, quotesCount;
        cancellationCount = changeCount = renewalCount = quotesCount = 0;
        accountData?.filter(ad => ad.producerCode == producerCode)?.forEach(accountDetails => {
            if (accountDetails.openSubmissions) {
                quotesCount += accountDetails.openSubmissions;
            }
            if (accountDetails.openRenewals) {
                renewalCount += accountDetails.openRenewals;
            }
            if (accountDetails.openPolicyChanges) {
                changeCount += accountDetails.openPolicyChanges;
            }
            if (accountDetails.openCancellations) {
                cancellationCount += accountDetails.openCancellations;
            }
            if (recentlyIssuedCount) {
                accountDetails.recentlyIssuedCount = recentlyIssuedCount;
            }
            if (delinquentCount) {
                accountDetails.delinquentCount = delinquentCount;
            }
        });
        const requal = _.isNull(renewalRequalificationCount) ? '-' : renewalRequalificationCount; 
        this.setState({
            quotesCount,
            renewalCount,
            changeCount,
            renewalRequalificationCount: requal,
            cancellationCount,
        });
    };

    getActiveTileValue = currentView => {
        const { [`${currentView}Count`]: value } = this.state;
        return value;
    };

    onChangeAdvanceFilter = value => {
        const { producerCode: selectedProducerCode } = this.props;
        if (!this.state.skipAdvancedLoad) {
            // DE19045 on initial switch to advanced view, do no reload table
            this.setState({reloadPolicyTable: Math.random()});
        }
        this.setState(
            {
                currentView: value.currentView,
                statusCodes: value.statusCodes,
                billingStatusCodes: value.billingStatusCodes,
                lobCodes: value.lobCodes,
                skipAdvancedLoad: false,
            },
            () =>
                this.triggerGetResponse(value.currentView, selectedProducerCode)
        );
    };

    parseCase = id => _.upperFirst(id);

    triggerGetResponse = (id, producerCode) => {
        const checkTableDataType =
            currentViews.indexOf(this.parseCase(id)) >= 0;
        if (checkTableDataType) {
            this.getAccountResponseData(producerCode);
        } else {
            this.getResponse(id, producerCode);
        }
        this.getTileValue(producerCode);
    };

    handleOnClick = async id => {
        const { producerCode: selectedProducerCode } = this.props;
        // this resets the pagination
        this.setState({
            recentlyViewedTableVisible: false,
            policyTableVisible: false, 
        });
        this.setState(
            {
                currentView: id,
            },
            () => {
                this.triggerGetResponse(id, selectedProducerCode);
            }
        );
    };

    handleValueChange = producerCode => {
        const { currentView } = this.state;
        this.triggerGetResponse(currentView, producerCode);
    };

    getCurrencyCell = (item, index, { id: property }) => {
        const translator = this.context;
        const totalPremiumCurrencyId = `totalPremium_${index}`;
        return (
            <span title={translator(messages.premium)}>
                <CurrencyField
                    id={totalPremiumCurrencyId}
                    value={item[property]}
                    dataType="object"
                    readOnly
                    hideLabel
                    showOptional={false}
                />
            </span>
        );
    };

    getCell = (item, index, { id: property }) => {
        const translator = this.context;
        let toolTipMessage = '';

        switch (property) {
            case 'created':
                toolTipMessage = translator(messages.created);
                break;
            case 'jobStatus':
                toolTipMessage = translator(messages.jobStatus);
                break;
            case 'effectiveDate':
                toolTipMessage = translator(messages.effectiveDate);
                break;
            case 'expirationDate':
                toolTipMessage = translator(messages.expirationDate);
                break;
            default:
                toolTipMessage = '';
        }
        return <span title={toolTipMessage}>{item[property]}</span>;
    };

    getProductImage = item => {
        const icon = LobIconUtil.getFontIcon(item.productCode);
        const translator = this.context;
        const productCode = _.lowerFirst(item.productCode);
        let toolTipMessage = '';

        switch (productCode) {
            case 'homeowners':
                toolTipMessage = translator(messages.residential);
                break;
            case 'commercialProperty':
                toolTipMessage = translator(messages.commercial);
                break;
            default:
                toolTipMessage = '';
        }

        return (
            <Icon
                icon={icon}
                title={translator(toolTipMessage)}
            />
        );
    };

    getLink = (item, index, { id: property }) => {
        const { currentView } = this.state;
        const translator = this.context;
        let toolTipMessage = '';
        let redirectRoute = '';

        switch (property) {
            case 'policyNumber':
                toolTipMessage = translator(messages.policyNumber);
                redirectRoute = 'policies';
                break;
            case 'jobNumber':
                toolTipMessage = translator(messages.jobNumber);
                redirectRoute = currentView;
                break;
            default:
                toolTipMessage = '';
        }
        
        if (property === 'jobNumber') {
            if(!item.canUserView) {
                return <span>{item[property]}</span>;
            }
            
            // 2025-08-21 - Debra Frum - DE19469 - PE: Mammoth -TFPA renewals currently shows the Edit Renewal button and message 
            //   which is applicable for TWIA only. These shouldn't be displayed for TFPA renewals
            // Use case-insensitive comparison of current view when switching between Quick Filters and Advanced Filter
            if (currentView.toLowerCase() === 'renewal' && this.props.authUserData.associationName_TWIA === 'tfpa') {
                return (
                    <FieldLinkComponent
                        id={`policy${item[property]}`}
                        to={`/policy-job-details/${item[property]}`}
                        className={styles.removeLinkStyle}
                        title={translator(toolTipMessage)}
                        value={item[property]}
                    />
                )
            }
    
            return (
                <FieldLinkComponent
                    id={`policy${item[property]}`}
                    to={`/${redirectRoute}/${item[property]}/summary`}
                    className={styles.removeLinkStyle}
                    title={translator(toolTipMessage)}
                    value={item[property]}
                />
            );
        }

        return (
            <FieldLinkComponent
                id={`policy${item[property]}`}
                to={`/${redirectRoute}/${item[property]}/summary`}
                className={styles.removeLinkStyle}
                title={translator(toolTipMessage)}
                value={item[property]}
            />
        );
    };

    getAccountNumberLink = (item, index, { id: property }) => {
        const { accountHolderName } = item;
        const translator = this.context;
        let toolTipMessage = '';
        let redirectRoute = '';

        switch (property) {
            case 'account':
            case 'accountNumber':
                toolTipMessage = translator(messages.account);
                redirectRoute = 'accounts';
                break;
            default:
                toolTipMessage = '';
        }

        return (
            <FieldLinkComponent
                id={`account${item[property]}`}
                to={`/${redirectRoute}/${item[property]}/summary`}
                className={styles.removeLinkStyle}
                title={translator(toolTipMessage)}
                value={accountHolderName}
            />
        );
    };

    handleFilterClick = async () => {
        const {
            toggleFilter,
            currentJobsResponse,
            policyResponse,
            delinquentData,
        } = this.state;
        let { currentView } = this.state;
        const { authHeader, producerCode: selectedProducerCode } = this.props;

        this.setState({
            policyLandingLoader: true,
            tableConfig: defaultTableConfig,
        });

        if (toggleFilter) {
            this.setState({
                toggleFilter: !toggleFilter,
                policyLandingLoader: false,
                skipAdvancedLoad: true,
            });
            this.triggerGetResponse(currentView, selectedProducerCode);
        } else {
            if (currentView === 'Policies') {
                currentView = 'recentlyViewedTile';
                this.setState({
                    currentView: currentView,
                    policyLandingLoader: false,
                });
            }

            const currentViewCondition =
                availableAdvancedFilterID.includes(currentView);

            if (currentViewCondition) {
                this.setState({
                    currentView: _.lowerFirst(currentView),
                    policyLandingLoader: false,
                });
            }

            this.setState(
                {
                    toggleFilter: !toggleFilter,
                    policyData: policyResponse,
                    accountData: currentJobsResponse,
                    policyLandingLoader: false,
                    statusCodes: [],
                    billingStatusCodes: [],
                    lobCodes: [],
                },
                () => this.triggerGetResponse(currentView, selectedProducerCode)
            );
        }
    };

    loadInitialData = async (viewSelected) => {
        const { authHeader, producerCode } = this.props;
        const selectedView = viewSelected || 'recentlyViewedTile'
        const policyDays = gatewayParamConfig.policiesCreatedInLastXDays;
        const jobsDays = gatewayParamConfig.jobsCreatedInLastXDays;
        // const requalDays = gatewayParamConfig.requalificationRenewalsCreatedInLastXDays;

        const recentlyViewedPolicies = PolicyService.getRecentlyViewedPolicies(
            authHeader
        ).then(policyResponse => {
            this.setState({
                policyData: policyResponse,
                policyResponse,
            });
            this.getResponse(selectedView, producerCode);
        });

        const accountJobsForCurrentUser = AccountService.getAccountJobsSummariesForCurrentUser_TWIA(
                producerCode, jobsDays, null, null, authHeader).then(currentJobsResponse => {
            this.setState({
                accountData: currentJobsResponse,
                currentJobsResponse,
            });
            this.getTileValue(producerCode);
        });

        PolicyService.getRecentlyIssuedStatus(
                producerCode, policyDays, authHeader).then(codes => {
            this.setState({ policyStatusCodes: codes });
        });

        PolicyService.getRecentlyIssuedLOBs(
                producerCode, jobsDays, authHeader).then(codes => {
            this.setState({ policyLobs: codes });
        });

        AccountService.getAccountJobTypesForCurrentUser_TWIA(
            producerCode, jobsDays, authHeader
        ).then(jobTypes => {
            this.setState({
                jobTypes: jobTypes,
            });
        });

        PolicyService.getRecentlyIssuedPolicyCount(
            producerCode, policyDays, authHeader
        ).then(count => {
            this.setState({ recentlyIssuedCount: count });
        });

        PolicyService.getDelinquentPolicyCount(producerCode, null, null, authHeader)
        .then(data => {
            this.setState({
                delinquentCount: data 
            });
        });

        const requalJobCount = JobService.getRequalificationJobCount(producerCode,
            gatewayParamConfig.requalificationRenewalsCreatedInLastXDays, authHeader
        ).then(data => {
            this.setState({
                renewalRequalificationCount: data 
            });
        });

        Promise.all([
            recentlyViewedPolicies,
            accountJobsForCurrentUser,
            requalJobCount,
        ])
            .then(() => {
                this.setState({
                    policyLandingLoader: false,
                }, () => { 
                    this.triggerGetResponse(selectedView, producerCode);                   
                });
                
            })
            .catch(() => {
                this.setState({
                    policyLandingLoader: false,
                });
            });
    };

    getViewedInfo = () => {
        const { currentView } = this.state;
        const translator = this.context;
        const availableAdvanceFilterID = [
            'recentlyViewedTile',
            'delinquentTile',
            'Policies',
            'Quotes',
            'Renewal',
            'Change',
            'Cancellation',
            'RenewalRequalification'
        ];
        const checkAdvanceFilterID = availableAdvanceFilterID.some(
            val => val === currentView
        );

        if (checkAdvanceFilterID) {
            return translator(tableHeadings[currentView]);
        }

        if (currentView === 'recentlyIssuedTile') {
            return translator(messages.recentlyIssuedPolicyForPastXDays, {
                value: gatewayParamConfig.policiesCreatedInLastXDays,
            });
        }

        const checkAccountID = availableAccountID.some(
            val => val === currentView
        );

        if (checkAccountID) {
            return translator(
                tableHeadings[currentView]
            );
        }

        return true;
    };

    getTableTitle = () => {
        const { currentView } = this.state;
        const translator = this.context;
        const title = this.getViewedInfo();
        const buttonLabel = translator(messages.viewAll);

        return (
            <div className={styles.titleContainer}>
                <div>{title}</div>
                {   currentView !== "renewalRequalification" ? 
                    <Button onClick={this.handleFilterClick} label={buttonLabel} /> :
                    <span />
                }
            </div>
        )
    }

    loadRecentlyViewedTable = ({ sorted, pageSize, page }) => {
        const { authHeader, producerCode} = this.props;
        const { 
            accountData,
            currentView, 
            tableData, 
            delinquentCount, 
            statusCodes,
            billingStatusCodes,
            lobCodes,
            recentlyIssuedCount,
        } = this.state;
        const start = pageSize === 'All' ? 0 : page * pageSize;
        const displayObj = this.getRecentlyViewedDisplayObject;
        if (currentView === 'delinquentTile') {
            const end =  pageSize === 'All' ? delinquentCount : (page + 1) * pageSize;
            return PolicyService.getDelinquentPolicies(producerCode, null, null,
                    start, end, authHeader).then(result => {
                if (! _.isEmpty(result.policySummaries)) {
                    const jobs = result.policySummaries;
                    const displayObjects = jobs.map(displayObj);
                    return { rows: displayObjects, numberOfRows: result.numberOfRows };
                } else {
                    return { rows: [], numberOfRows: 0 };
                }
            });
        } else if (currentView === 'recentlyIssuedTile') {
            const end = pageSize === 'All' ? recentlyIssuedCount : (page + 1) * pageSize;
            const lastXDays = gatewayParamConfig.policiesCreatedInLastXDays;
            return PolicyService.getRecentlyIssuedPolicies_TWIA(producerCode,
                    lastXDays, null, null, start, end, authHeader).then(result => {
                if (! _.isEmpty(result.policySummaries)) {
                    const summaries = result.policySummaries;
                    const displayObjects = summaries.map(displayObj);
                    return { rows: displayObjects, numberOfRows: result.numberOfRows };
                } else {
                    return { rows: [], numberOfRows: 0 };
                }
            });
        } else if (currentView === 'Policies') {
            const currentCount = accountData.find(ad => ad.producerCode == producerCode);
            const iad = currentCount?.issuedAndDelinquent;
            const rad = recentlyIssuedCount + delinquentCount;
            const fullCount = iad && iad > rad ? iad : rad;
            const end = pageSize === 'All' ? fullCount : (page + 1) * pageSize;
            const lastXDays = gatewayParamConfig.policiesCreatedInLastXDays;
            // DE18898 use combined function
            return PolicyService.getRecentyIssuedAndDelinquentPolicies(producerCode, lastXDays, 
                        billingStatusCodes, statusCodes, lobCodes, start, end, authHeader).then(result => {
                const summaries = result.policySummaries;
                if (summaries) {
                    const displayObjects = summaries.map(displayObj);
                    currentCount.issuedAndDelinquent = result.numberOfRows;
                    this.setState({ accountData: accountData });
                    return { rows: displayObjects, numberOfRows: result.numberOfRows };
                } else {
                    return { rows: [], numberOfRows: 0 };
                }
            });
        } else {
            const end = pageSize === 'All' ? tableData.length : (page + 1) * pageSize;
            const slice = tableData.slice(start, end);
            const len = tableData && tableData.length ? tableData.length : 0;
            return Promise.resolve({rows: slice, numberOfRows: len});
        } 
    }

    getCountFieldName = () => {
        switch(this.parseCase(this.state.currentView)) {
            case 'Quotes': return 'openSubmissions';
            case 'Renewal': return 'openRenewals';
            case 'Change': return 'openPolicyChanges';
            case 'Cancellation': return 'openCancellations';
        }
    }

    loadPolicyTable = ({ sorted, pageSize, page }) => {
        const { authHeader, producerCode, intl } = this.props;
        const { currentView, statusCodes, accountData, lobCodes } = this.state;
        const translator = this.context;
        const jobType = currentViewsToJobType[this.parseCase(currentView)];
        const count = this.state[currentViewsToCount[this.parseCase(currentView)]];
        const start = pageSize === 'All' ? 0 : page * pageSize;
        const end =  pageSize === 'All' ? count : (page + 1) * pageSize;
        const createdIn = gatewayParamConfig.jobsCreatedInLastXDays;
        const displayObj = this.getPolicyDisplayObject;
        if (currentView === 'renewalRequalification') {
            return JobService.requalificationJobsForCurrentUser(producerCode,
                    gatewayParamConfig.requalificationRenewalsCreatedInLastXDays, start, end, authHeader).then(jobs => {
                const displayObjects = jobs.map(j => displayObj(j, producerCode, translator, intl));
                return { rows: displayObjects, numberOfRows: count };
            });
        } else if (jobType) {
            return JobService.jobsByTypeForCurrentUser(producerCode,
                    createdIn, jobType, statusCodes, lobCodes, start, end, authHeader).then(result => {
                const displayObjects = result.jobSummaries?.map(j => displayObj(j, producerCode, translator, intl));
                const currentCount = accountData.find(ad => ad.producerCode == producerCode);
                const fieldName = this.getCountFieldName();
                if (currentCount && currentCount[fieldName] != result.numberOfRows) {
                    currentCount[fieldName] = result.numberOfRows;
                    this.setState({ accountData: accountData });
                }
                return { rows: displayObjects, numberOfRows: result.numberOfRows };
            });
        }
    }

    tableConfigChange = config => {
        const tableConfig = _.clone(config);
        this.setState({ tableConfig });
    }

    render() {
        const {
            cancellationCount,
            changeCount,
            renewalRequalificationCount,
            quotesCount,
            renewalCount,
            toggleFilter,
            recentlyViewedTableVisible,
            toggleNoDataMsg,
            policyTableVisible,
            currentView,
            accountData,
            policyLandingLoader,
            policyNumberVisible,
            allDelinquentPolicies,
            tableData,
            policyStatusCodes,
            policyLobs,
            jobTypes,
            reloadPolicyTable, 
        } = this.state;
        const overrides = {
            policyViewedInfo: {
                content: toggleFilter ? this.getTableTitle() : this.getViewedInfo(),
            },
            policyLandingLoader: {
                loaded: !policyLandingLoader,
            },
            policyContentContainer: {
                visible: !policyLandingLoader,
            },
            tableContainer: {
                className: cx(styles.gwPoliciesContainerSection, {
                    [styles.gwPolicyInfoQuickTable]: toggleFilter,
                    [styles.gwPolicyInfoAdvancedTable]: !toggleFilter,
                }),
            },
            recentlyViewedPoliciesTableGrid: {
                onFetchData: this.loadRecentlyViewedTable,
                onConfigChange: this.tableConfigChange,
                config: this.state.tableConfig,
                data: tableData,
                visible: recentlyViewedTableVisible,
            },
            noDataMessageContainer: {
                visible: toggleNoDataMsg,
            },
            openPolicyNumberTitle: {
                visible: policyNumberVisible && currentView !== "quotes" && currentView !== "Quotes"
            },
            effectiveDateTitle1: {
                visible: ['quotes', 'renewal', 'Quotes', 'Renewal' ].includes(currentView)
            },
            jobStatusTitle1: {
                visible: currentView !== "renewalRequalification"
            },
            createdTitle: { 
                visible: currentView !== "renewalRequalification"
            },
            insurednameTitle1: {
                visible: currentView !== "renewalRequalification"
            },
            quoteExpires: {
                visible: currentView !== "renewalRequalification"
            },
            jobNumberTitle: {
                visible: currentView !== "renewalRequalification"
            },
            requalExpirationDate: {
                visible: currentView === "renewalRequalification"
            },
            requalStatusTitle: {
                visible: currentView === "renewalRequalification"
            },
            policyTable: {
                onFetchData: this.loadPolicyTable,
                numberOfRows: reloadPolicyTable, // DE19045 force reload of policy table
                visible: policyTableVisible,
            },
            policyPageTileContainer: {
                visible: toggleFilter,
            },
            policyAdvancedFilter: {
                visible: !toggleFilter,
                policyStatusCodes: policyStatusCodes,
                policyLobs: policyLobs,
                counts: accountData,
                jobTypes: jobTypes,
                clickedTile: currentView,
            },
            quotes: {
                value: quotesCount,
            },
            renewal: {
                value: renewalCount,
            },
            change: {
                value: changeCount,
            },
            renewalRequalification: {
                value: renewalRequalificationCount,
            },
            cancellation: {
                value: cancellationCount,
            },
            advanceFilterLink: {
                visible: toggleFilter,
            },
            quickFilterLink: {
                visible: !toggleFilter,
            },
            [currentView]: {
                active: true,
                value: this.getActiveTileValue(currentView),
            },
            availableProducerCode:{
                hideMyWork: false
            },
            switchTo: {
                visible: currentView !== "renewalRequalification",
            },
            filterContainer: {
                visible: currentView !== "renewalRequalification",
            },
        };

        const resolvers = {
            resolveComponentMap: {
                advancedfilter: PolicyAdvanceFilter,
                selectproducercode: SelectProducerCode,
            },
            resolveCallbackMap: {
                getCell: this.getCell,
                getProductImage: this.getProductImage,
                getLink: this.getLink,
                getAccountNumberLink: this.getAccountNumberLink,
                getCurrencyCell: this.getCurrencyCell,
                handleOnClick: this.handleOnClick,
                handleValueChange: this.handleValueChange,
                handleFilterClick: this.handleFilterClick,
                onFilterValueChange: this.onChangeAdvanceFilter,
                sortDate: DatatableUtil.sortDate,
                sortString: DatatableUtil.sortString,
                sortNumber: DatatableUtil.sortNumber,
                sortCurrency: DatatableUtil.sortCurrency,
                dateFormatValue: this.dateFormatValue
            },
            resolveClassNameMap: styles,
        };

        const policyLandingPage = (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );
        return policyLandingPage;
    }
}
export const PoliciesPage = Policies;
export default withRouter(
    withIntl(withAuthenticationContext(withProducerContext(Policies)))
);
